import { FieldArray, FormikProvider, useFormik } from "formik";
import numeral from "numeral";
import React from "react";
import ModalBasic from "../../components/infrastructure/Modals/ModalBasic";
import {
  BILL_NUMBER_PADDING,
  CASHBOOK_PAYMENT_METHODS,
  PAYMENT_METHODS,
} from "../../utils/dropdownOptions";
import FormikInputGroup from "../../components/formik/FormikInputGroup";
import SecondaryButton from "../../components/infrastructure/Buttons/SecondaryButton";
import FormikSelectGroup from "../../components/formik/FormikSelectGroup";
import FormikInputDateGroup from "../../components/formik/FormikInputDateGroup";
import { X } from "react-feather";
import { generateOptions } from "../../utils/Utils";
import { useEffect } from "react";
import PrimaryButton from "../../components/infrastructure/Buttons/PrimaryButton";
import { authAxiosInstance } from "../../utils/axiosConfig";
import { createSale } from "../../app/reducers/Sale/saleSlice";
import { useDispatch, useSelector } from 'react-redux'
import { toast } from "react-toastify";
import { fetchCreditBooks } from "../../app/reducers/CreditBook/creditBookSlice";
import { fetchLocations, getLocation } from "../../app/reducers/Location/locationSlice";
import * as Yup from 'yup'

const CustomerReceiveModal = ({
  showReceivedModal,
  setShowReceivedModal,
  saleData
}) => {

  const { location, loading: locationLoading } = useSelector(getLocation);
  const locationInfoId = localStorage.getItem("locationInfoId")

  useEffect(() => {
    dispatch(fetchLocations())
  },[])


  const dispatch = useDispatch()
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      location: locationInfoId ? locationInfoId : '',
      amount: 0,
      user: saleData && saleData.user,
      type: ''
    },
    validationSchema: Yup.object({
      location: Yup.string().required(),
      type: Yup.string().required(),
      user: Yup.string().required(),
      amount: Yup.number().min(1).required(),
  }),
    onSubmit: async (values) => {
      const data = {
        user: values.user,
        amount: values.amount,
        type: values.type,
        location: values.location
      }
      const productData = await authAxiosInstance.post(`creditBook/receive`, data);
      if (productData) {
        toast.success("Amount Added Successfully...")
        dispatch(fetchCreditBooks({ user: values.user, populate: true, sort: { createdAt: 1 } }))
        formik.resetForm()
        setShowReceivedModal(false)
      }
    }
  });


  return (
    <ModalBasic
      modalOpen={showReceivedModal}
      setModalOpen={setShowReceivedModal}
    >
      {/* <h1 className="p-10 font-bold">Under Development</h1> */}
      <form onSubmit={formik.handleSubmit} className="flex flex-col gap-4 p-4">
        <FormikInputGroup
          label="User"
          formik={formik}
          readOnly
          name="user"
        />
        <FormikSelectGroup
          name="location"
          label="Location/Store"
          formik={formik}
          options={generateOptions({
            array: location?.docs ? location?.docs : [],
            valueField: "_id",
            labelField: "name",
          })}
        />
        <FormikSelectGroup
          name="type"
          label="Payment type"
          formik={formik}
          options={generateOptions({
            array: CASHBOOK_PAYMENT_METHODS,
            valueField: "value",
            labelField: "label",
          })}
        />
        <FormikInputGroup
          label="Amount"
          formik={formik}
          type="number"
          name="amount"
        />
        <div>
          <PrimaryButton type="submit">Submit</PrimaryButton>
        </div>
      </form>
    </ModalBasic>
  );
};

export default CustomerReceiveModal;
